import { DbTable } from '../data/dbcontext.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  ChangeHistoryFilters,
  ChangeEntryProperty,
  ChangeEntry,
  ChangeHistorySummary
} from '../../models/change-history/change-history.models';
import { AppConfig } from '../../app/app.config';
import { ImplementerDateService } from '../implementer/implementer-date.service';
import { DateParserService } from '../daily-log/daily-log-time/date-parser-service';
import { TimeZoneService } from '../time-zone/time-zone.service';

@Injectable()
export class ChangeHistoryService {

  config = AppConfig.settings;

  private readonly dailyLogTable: DbTable;
  private readonly millisecondsInDay = 86400000;

  constructor(
    private http: HttpClient,
    private implementerDateService: ImplementerDateService,
    private dateParserService: DateParserService,
    private timeZoneService: TimeZoneService,
  ) {
  }

  async getChangeHistoryForDate(filters: ChangeHistoryFilters): Promise<ChangeHistorySummary[]> {
    const url = `${this.config.apiUrl}api/changehistory/gethistoryfordate`;

    // add offsets before sending to api
    filters.dailyLogDate = filters.dailyLogDate
      ? this.dateParserService.removeOffsetFromLuxonDate(filters.dailyLogDate)
      : null;
    filters.recordFilters.startDailyLogDate = filters.recordFilters.startDailyLogDate
      ? this.dateParserService.removeOffsetFromLuxonDate(filters.recordFilters.startDailyLogDate)
      : null;
    filters.recordFilters.creationTimeFilterDate = filters.recordFilters.creationTimeFilterDate
      ? this.dateParserService.removeOffsetFromLuxonDate(filters.recordFilters.creationTimeFilterDate)
      : null;

    let result = await this.http
      .post<ChangeHistorySummary[]>(url, filters)
      .toPromise();

    result = await this.setChangeHistorySummaryLocalDates(result);

    return result;
  }

  async getDeserializedRecords(changeHistoryId: number): Promise<ChangeEntry[]> {
    const url = `${this.config.apiUrl}api/changehistory/${changeHistoryId}/getdeserializedrecords`;
    const result = await this.http.get<ChangeEntry[]>(url).toPromise();
    return await this.deserializeChangeEntries(result);
  }

  async deserializeChangeEntries(changeEntries: ChangeEntry[]): Promise<ChangeEntry[]> {
    for (let i = 0; i < changeEntries.length; i++) {
      changeEntries[i].timeOfChange = await this.dateParserService.deserializeDate(changeEntries[i].timeOfChange, true, this.timeZoneService);
    }

    return changeEntries;
  }

  async getPropertiesForEvent(changeRecord: ChangeEntry) {
    const url = `${this.config.apiUrl}api/changehistory/geteventproperties`;

    let result = await this.http
      .post<ChangeEntryProperty[]>(url, changeRecord)
      .toPromise();

    return result;
  }

  async setChangeHistorySummaryLocalDates(result: ChangeHistorySummary[]): Promise<ChangeHistorySummary[]> {
    for (let i = 0; i < result.length; i++) {
      if (result[i].implementerSnapshotSummary) {
        result[i].implementerSnapshotSummary = await this.implementerDateService.setImplementerSnapshotSummaryLocalDates(result[i].implementerSnapshotSummary);
      }
    }

    return result;
  }
}



// WEBPACK FOOTER //
// ./src/services/change-history/change-history-service.ts